export const rangoFechas = {
  desde: "من",
  hasta: "إلى",
  etiqueta: "التواريخ",
  quitar: "إزالة التواريخ",
  titulo: "اختر التواريخ",
  elegirInicio: "اختر اليوم الأول",
  elegirFin: "الآن اختر اليوم الأخير",
  dias: "يوم | أيام",
  anterior: "الشهر السابق",
  siguiente: "الشهر التالي",
  cancelar: "إلغاء",
  aplicar: "تطبيق",
};
